<template>
  <div>
    <p class="text-hex-fff mb-14px" v-for="file in fileList" :key="file.id">
      {{ file.name }}
      <span class="text-[#00BCC8] pl-5px cursor-pointer" @click="downFile(file)">下载</span>
    </p>
  </div>
</template>
<script>
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
export default {
  name: 'plan-file-list',
  props: {
    fileIdList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      fileList: [],
    }
  },
  watch: {
    fileIdList: {
      handler(newVal, oldVal) {
        this.fileList = []
        newVal.length && this.getFileDetail()
      },
      immediate: true,
    },
  },
  methods: {
    getFileDetail() {
      _.forEach(this.fileIdList, async (fileId) => {
        const file = await this.getFile(fileId)
        this.fileList.push(file)
      })
    },
    /**
     * @description 获取文件
     */
    async getFile(id) {
      const [err, res] = await fileApi.get(id)
      if (!err) {
        return res
      }
      return null
    },
    // 导出
    async downFile(data) {
      const [err, res] = await fileApi.download(data.id, { returnType: 'Blob' })
      if (err) return
      const type = data.name.slice(data.name.lastIndexOf('.') + 1)
      this.downLoadExcel(data.name, res, type)
      this.$message({
        showClose: true,
        message: '下载成功',
        type: 'success',
      })
    },
    // 文件流下载
    downLoadExcel(fileName = '下载文件', data, type) {
      const fileType = {
        zip: 'application/zip',
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        jepg: 'image/jpeg',
        excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
      const blob = new Blob([data], {
        type: fileType[type],
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
  },
}
</script>
<style lang="scss" scoped>
.file-text {
  color: #fff;
}
</style>
